<template>
  <div class="page-template">
    <el-row :style="{height: `${topEmptyRowHeight}px`}" v-show="topEmptyRow"></el-row>
    <el-row type="flex" :gutter="0">
      <el-col :span="5">
      </el-col>
      <el-col :span="14" class="page-template-content-min-width" >
        <slot ></slot>
      </el-col>
      <el-col :span="5">
      </el-col>
    </el-row>
    <el-row :style="{height: `${bottomEmptyRowHeight}px`}" v-show="bottomEmptyRow"></el-row>
  </div>
</template>
<style lang="scss">
</style>
<script>
export default {
  /**
   * 页面布局模板PageTemplate
   */
  name: 'PageTemplate',
  props: {
    // 渲染数组
    topEmptyRow: {
      type: Boolean,
      default: true
    },
    topEmptyRowHeight: {
      type: Number,
      default: 20
    },
    bottomEmptyRow: {
      type: Boolean,
      default: true
    },
    bottomEmptyRowHeight: {
      type: Number,
      default: 10
    },
    // 是否显示页面导航
    isShowBreadcrumb: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  created () {
  },
  watch: {
  },
  methods: {
  },
  mounted () {
  },
  computed: {
  }
}
</script>
<style scoped>
.page-template-content-min-width { 
  min-width: 1366px;
}
</style>



// WEBPACK FOOTER //
// src/components/PageTemplate.vue